

export class Attachments {

    private _model : any;
    constructor(private _modelDefined: any) {
        this._model = this._modelDefined ? angular.copy(this._modelDefined) : {};
    }

    get attachementName(): string {
        return this._model.attachementName;
    }

    set attachementName(val: string) {
        this._model.attachementName = val;
    }

    get attachmentId(): string {
        return this._model.attachmentId;
    }

    set attachmentId(val: string) {
        this._model.attachmentId = val;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/attachments.ts
 **/